import React, { useState } from "react";
import { Link } from "react-router-dom";
import NavbarLinks from "./NavbarLinks";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="navbar">
      <div className="navtitle">
        <Link to="/" onClick={closeMobileMenu}>joerickard.</Link>
      </div>
      <div className="hamburger" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      <NavbarLinks isMobileMenuOpen={isMobileMenuOpen} closeMobileMenu={closeMobileMenu}></NavbarLinks>
    </div>
  );
};

export default Navbar;
